import React, { useState } from 'react';
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { Avatar, Card, Form, Typography, Upload, UploadProps } from 'antd';
import { Delete, Download, FileDownload, FileOpen, ShowChart, UploadFile, UploadSharp } from '@mui/icons-material';
import { Box, CircularProgress, IconButton } from '@mui/material';
import Empty from '../Res/boite-de-reception.png'
import Format from '../Functions/Traitement/Format';
import { useNavigate } from 'react-router-dom';
import file from "../Res/Files-High-Quality-PNG.png"


const { Meta } = Card;

function    File(props:{file? : string, name: string, form?: any, label?: string}) {
    const [filebase64,setFileBase64] = useState<string>(props.file? props.file : "no file")
    const [fichier, setFichier] = useState<File>()
    const [load, setLoad] = useState<Boolean>(false)
    const navigate = useNavigate();
    const [view, setVeiw] = useState(false)

    function convertFile(files: FileList|null) {
        props.form.setFieldValue("fichier", undefined)
        setLoad(true)
        setFileBase64("no file")
        if (files) {
            setFichier(files[0])
            //console.log(files)
            const fileRef = files[0] || ""
            const fileType: string= fileRef.type || ""
            //console.log("This file upload is of type:",fileType)
            const reader = new FileReader()
            reader.readAsBinaryString(fileRef)
            reader.onload=(ev: any) => {
                // convert it to base64
                let data = `data:${fileType};base64,${btoa(ev.target.result)}`
                setFileBase64(data)
                //console.log(`data:${fileType};base64,${btoa(ev.target.result)}`)
                props.form.setFieldValue("fichier", data)
            }
            setLoad(false)
        }
        else{
            setFileBase64("no file")
            setLoad(false)
        }
    }
  
    function download(){
      var a = document.createElement("a"); //Create <a>
      a.href = filebase64; //Image Base64 Goes here
      a.download = fichier?.name+""; //File name Here
      a.click(); //Downloaded file
    }
    function openFile(){
        setVeiw(!view)
      }

    function reset(){
        setFileBase64("no file")
        setFichier(undefined)
    }

    setTimeout(() => {
        if (props.form.getFieldValue(props.name) == undefined) {
            setFileBase64("no file")
        }
        else{
            setFileBase64(props.form.getFieldValue(props.name))
            //setFichier(props.form.getFieldValue(props.name))
        }
      }, 1);
  
    return(
        <>
            <Typography className='label'>{props.label}</Typography>
            <Card
                size='small'
                style={{ width: 250}}
                cover={
                    view?
                    load? 
                    <Box className='file'>
                        <Box color={"gray"} marginLeft={"45%"} marginTop={"10%"}>
                            <CircularProgress /> <br />
                            <Typography style={{color: "gray", marginLeft: "-5px"}} className='texte'>Chargement du fichier</Typography>
                        </Box>
                    </Box>
                    :
                    filebase64 != "no file"
                    ?
                    (filebase64.indexOf("image/") > -1)?
                    <img width={150} height={150} src={filebase64} />
                    :
                    (filebase64.indexOf("video/") > -1)?
                    <video controls>
                        <source src={filebase64} />
                    </video>
                    :
                    (filebase64.indexOf("audio/") > -1)?
                    <audio controls>
                        <source src={filebase64} />
                    </audio>
                    :

                    <embed  src={filebase64} />
                    :
                    <Box className='file'>
                        <Box color={"gray"} marginLeft={"45%"} marginTop={"10%"}>
                            <img src={Empty} width={"25%"} /><br />
                            <Typography style={{color: "gray", marginLeft: "-15px"}} className='texte'>Aucun fichier sélectionné</Typography>
                        </Box>
                    </Box>
                :
                ""
                }
                actions={[
                    <IconButton size='small'><input type='file' onChange={(e) => convertFile(e.target.files)} /><UploadSharp titleAccess='Upload File'/></IconButton>,
                    <IconButton onClick={openFile} disabled={filebase64 == "no file"? true: false} size='small'><a href={filebase64}><FileOpen fontSize='small' titleAccess='Open File' /></a></IconButton>,
                    <IconButton disabled={filebase64 == "no file"? true: false} size='small' onClick={download}><Download titleAccess='Download File' /></IconButton>,
                    <IconButton disabled={filebase64 == "no file"? true: false} onClick={reset} size='small'><Delete fontSize='small' titleAccess='Delete file' /></IconButton>,
                ]}
            >
                {filebase64 != "no file"
                    ? 
                    <Box display={"flex"} fontStyle={"inherit"}>
                        <Form.Item name={props.name} />
                        <Avatar shape='square' src={fichier?.type.includes("image")? filebase64 : file} />
                        <Meta
                            title={fichier?.type? "["+fichier?.type+"]" : ""}
                            description={fichier?.name+"\n("+(new Format()).Auto(parseInt(fichier?.size+"", ))+")"}
                        />
                    </Box>
                    :
                    ""
                }
            </Card>
        </>
    );
}
export default File;